import Link from 'next/link'

const PrivacyPolicy_EN_US = () => {
    return <Link href="/privacy-policy" locale="es-ES"><a>We are in process of translating the text of the privacy policy. Meanwhile, you can see it in Spanish.</a></Link>
}

export default PrivacyPolicy_EN_US
